module.exports = __webpack_public_path__ + "charttype-sprites.53f94220ba77503ff550.png";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/common-images/spreadsheet/charttype-sprites.png
// module id = ../../../../syncfusion-javascript/Content/ej/web/common-images/spreadsheet/charttype-sprites.png
// module chunks = 2